<ng-container *ngIf="ready == false">
  <mat-card appearance="outlined">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </mat-card>
</ng-container>

<ng-container *ngIf="ready">
  <ng-container *ngIf="paided === false && depositSaved === false">
    <div class="row mb-3">
      <div class="col-4">
        <p>
          <strong>Restante: {{remaining}}</strong>
        </p>
      </div>
      <div class="col-8">
        <button mat-stroked-button class="pull-right me-3" (click)="closeDialog()">
          Cerrar
        </button>
        <button mat-stroked-button class="btn-convfact  me-3 pull-right" (click)="pay()">
          <mat-icon>save</mat-icon>
          {{ isEditMode === true ? 'Actualizar pago' : 'Pagar'}}
        </button>
        <button mat-stroked-button (click)="allocateRemaining()" class="btn-convfact  me-3 pull-right">Asignar
          restante</button>
      </div>

      <div class="col-4">
        <mat-form-field class="w-100 mb-2">
          <mat-label>Fecha de pago</mat-label>
          <input matInput [matDatepicker]="Paided" placeholder="" name="investmentDeposit.depositDate" required
            [(ngModel)]="investmentDeposit.depositDate" />
          <mat-datepicker-toggle matSuffix [for]="Paided"></mat-datepicker-toggle>
          <mat-datepicker #Paided></mat-datepicker>
          <mat-error *ngIf="invalidDate">Campo requerido</mat-error>
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field class="w-100 mb-2">
          <input type="number" matInput placeholder="Cantidad" type="number" [(ngModel)]="investmentDeposit.amount"
            value="investmentDeposit.amount" class="" required numberDecimalsDirective>
          <mat-error *ngIf="invalidAmount">Campo requerido</mat-error>
        </mat-form-field>
      </div>

      <div class="col-4" *ngIf="investmentDeposit.typePay === 'Transferencia bancaria'">
        <div>Comisión</div>
        <mat-form-field class="w-100 mb-2">
          <input matInput placeholder="Comisión" type="number" [(ngModel)]="investmentDeposit.commissions"
            value="investmentDeposit.commissions" numberDecimalsDirective>
        </mat-form-field>
      </div>

      <div class="col-4">
        <app-select name="investmentDeposit.typePay" [(ngModel)]="investmentDeposit.typePay"
          [config]="{ label: 'Tipo de pago', placeholder: 'Seleccionar', required: true, options: billMethodsOptions }">
        </app-select>
      </div>

      <!-- Efectivo -->
      <div class="col-4" *ngIf="investmentDeposit.typePay === 'Efectivo'">
        <app-autocomplete-select [items]="efectivoList" [(selectedItemId)]="investmentDeposit.efectivoId"
          [idField]="'uid'" [displayField]="'nombre'" placeholder="Caja/Efectivo">
        </app-autocomplete-select>
      </div>

      <!-- Socio -->
      <div class="col-4" *ngIf="investmentDeposit.typePay === 'Socio'">
        <app-autocomplete-select [items]="sociosList" [(selectedItemId)]="investmentDeposit.partnersId"
          [idField]="'uid'" [displayField]="'nameOrBusinessName'" placeholder="Socios">
        </app-autocomplete-select>
      </div>

      <!-- Poliza de credito -->
      <div class="col-4" *ngIf="investmentDeposit.typePay === 'Póliza de crédito'">
        <app-autocomplete-select [items]="polizaCreditoList" [(selectedItemId)]="investmentDeposit.polizaCreditoId"
          [idField]="'uid'" [displayField]="'banco'" placeholder="Póliza de crédito">
        </app-autocomplete-select>
      </div>

      <!-- Transferencia bancaria -->
      <div class="col-4" *ngIf="investmentDeposit.typePay === 'Transferencia bancaria'">
        <app-autocomplete-select [items]="bankAccounts" [(selectedItemId)]="investmentDeposit.bankAccountsUid"
          [idField]="'uid'" [displayFields]="['bank', 'iban']" placeholder="Cuentas bancarias">
        </app-autocomplete-select>
      </div>

      <!-- Tarjeta de crédito -->
      <div class="col-4" *ngIf="investmentDeposit.typePay === 'Tarjeta de crédito'">
        <app-autocomplete-select [items]="paymentCards" [(selectedItemId)]="investmentDeposit.paymentCardsUid"
          [idField]="'uid'" [displayFields]="['name', 'number']" placeholder="Tarjetas de crédito">
        </app-autocomplete-select>
      </div>
    </div>
  </ng-container>

  <div class="row" *ngIf="depositSaved === true">
    <div class="col-12">
      <div>Depósito {{ isEditMode === true ? 'actualizado': 'añadido' }} correctamente</div>
      <button mat-stroked-button class="mt-3" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
        Cerrar
      </button>
    </div>
  </div>

  <!-- Listado -->
  <div class="row" *ngIf="list == true">
    <div>
      <div class="fc-black mt-3">Listado de pagos</div>
    </div>

    <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="false" [hasButton]="true"
      [actionsTemplate]="actionsButtons">
    </app-table>

    <ng-template #actionsButtons let-uid="uid">
      <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
        <ul class="custom-class">
          <li (click)="edit(uid)">
            <a>
              <mat-icon>create</mat-icon> Editar
            </a>
          </li>
          <li (click)="delete(uid)">
            <a>
              <mat-icon>warning</mat-icon> Borrar
            </a>
          </li>
        </ul>
      </ng-container>
    </ng-template>

  </div>

</ng-container>